const httpHeaders = {
  TRACE_ID: 'Trace-Id',
  APP_IDENTITY: 'App-Identity',
} as const;

export { httpHeaders };
